import EditProfileScene from './EditProfileScene'
export default EditProfileScene